import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../../i18n/useT';
import logoText from '../../assets/logo_text.png';
import './Footer.css';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const t = useT();
  const f = t.footer;

  const FOOTER_LINKS = {
    product: {
      title: f.product,
      links: [
        { to: '/features', label: f.links.features },
        { to: '/faq', label: f.links.faq },
        { to: '/support', label: f.links.support },
      ],
    },
    company: {
      title: f.company,
      links: [
        { to: '/contact', label: f.links.contact },
      ],
    },
    legal: {
      title: f.legal,
      links: [
        { to: '/privacy', label: f.links.privacy },
        { to: '/terms', label: f.links.terms },
        { to: '/impressum', label: f.links.impressum },
        { to: '/cookie-policy', label: f.links.cookiePolicy },
        { to: '/data-deletion', label: f.links.dataDeletion },
      ],
    },
  };

  return (
    <footer className="footer" aria-label="Site footer">
      <div className="container-wide">
        {/* Top Grid */}
        <div className="footer__grid">
          {/* Brand column */}
          <div className="footer__brand">
            <Link to="/" className="footer__logo" aria-label="Docudi – Home">
              <img src={logoText} alt="Docudi" className="footer__logo-img" />
            </Link>
            <p className="footer__tagline">{f.tagline}</p>
          </div>

          {/* Link columns */}
          {Object.values(FOOTER_LINKS).map((group) => (
            <div key={group.title} className="footer__column">
              <h3 className="footer__column-title">{group.title}</h3>
              <ul>
                {group.links.map(({ to, label }) => (
                  <li key={to}>
                    <Link to={to} className="footer__link">{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="footer__bottom">
          <p className="footer__copy">
            {f.copyright.replace('{year}', currentYear)}
          </p>
          <div className="footer__bottom-links">
            <Link to="/privacy" className="footer__bottom-link">{f.links.privacy}</Link>
            <Link to="/terms" className="footer__bottom-link">{f.links.terms}</Link>
            <Link to="/impressum" className="footer__bottom-link">{f.links.impressum}</Link>
            <Link to="/cookie-policy" className="footer__bottom-link">{f.links.cookiePolicy}</Link>
          </div>
          <p className="footer__compliance-note">{f.complianceNote}</p>
        </div>
      </div>
    </footer>
  );
}
